var _path, _radialGradient, _path2, _radialGradient2, _path3, _radialGradient3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPko(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.2 21c4.8 0 8.7-3.9 8.7-8.7s-3.9-8.7-8.7-8.7-8.7 3.9-8.7 8.7 3.9 8.7 8.7 8.7z",
    fill: "#E4202C"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    cy: 313.94,
    cx: -1328.6,
    gradientTransform: "matrix(1.1905 0 0 1.1905 1631.6 -350.07)",
    r: 50.449
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C9A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004994",
    offset: 0.1431
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013F84",
    offset: 0.3303
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#033069",
    offset: 0.5421
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051A43",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070016",
    offset: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m50.2 45.9c11.5 0 21.4-2.9 25.6-6.8 1.4-1.3 2.1-2.8 2.1-4.3s-0.8-2.9-2.1-4.3c-1.4-1.3-3.4-2.5-5.9-3.5-5-2-12-3.3-19.7-3.3h-0.1c-10.3 0-19.3 2.4-24.1 5.7-2.8 1.9-3.6 4.2-3.6 6.9v22.1 7.2 1.6c0 3.5 1 5 1.5 5.8 1.5 2.5 3.5 4.5 6 6l0.2 0.1v-36.7l0.2 0.1c5.1 2.1 12.1 3.4 19.9 3.4zm-11.7-11.5c-0.2-0.2-0.2-0.5-0.2-0.6 0-0.5 0.4-1.1 1-1.4 0.3-0.2 0.7-0.2 1-0.2h20.3c0.3 0 0.7 0.1 1 0.2 0.7 0.3 1 0.9 1 1.4 0 0.2-0.1 0.4-0.2 0.6-0.3 0.3-0.7 0.5-1.1 0.5h-21.7c-0.4 0-0.9-0.2-1.1-0.5z",
    fill: "url(#SVGID_1_)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    cy: 313.94,
    cx: -1328.6,
    gradientTransform: "matrix(1.1905 0 0 1.1905 1631.6 -350.07)",
    r: 50.457
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C9A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004994",
    offset: 0.1431
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013F84",
    offset: 0.3303
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#033069",
    offset: 0.5421
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051A43",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070016",
    offset: 1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m54.2 79.2v-8.8c0-2.7-2.2-4.8-4.9-4.9h-0.1v-0.8c2.8-0.3 4.9-2.5 4.9-5.3v-6.2c0-1.4 0.1-2.8 0.5-4.1l0.1-0.2h-0.2c-0.7 0.1-1.9 0.1-3.2 0.1-1.9 0-4-0.1-5.1-0.2h-0.2v0.1c-0.5 1.5-0.7 2.8-0.7 4.4v7c0 1.5-1.1 3.1-3.1 3.2v-15.1h-0.1c-3.4-0.4-5.9-1-8.6-1.9l-0.2-0.1v34.5h0.1c2.7 1.2 5.3 2 8.7 2.6h0.1v-17.5c1.9 0.1 3.1 1.6 3.1 3.2v9.6c0 2 0.4 3.6 0.9 5.3v0.1h0.1c0.7 0.1 1.8 0.1 3.1 0.1 1.8 0 3.9-0.1 5.3-0.3h0.1v-0.2c-0.4-1.5-0.6-2.9-0.6-4.6z",
    fill: "url(#SVGID_2_)"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    cy: 313.94,
    cx: -1328.6,
    gradientTransform: "matrix(1.1905 0 0 1.1905 1631.6 -350.07)",
    r: 50.445
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C9A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004994",
    offset: 0.1431
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013F84",
    offset: 0.3303
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#033069",
    offset: 0.5421
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051A43",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070016",
    offset: 1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m77.1 45c0-0.8-0.7-1.5-1.5-1.5-0.2 0-0.5 0.1-0.7 0.2-3.8 2.2-9.2 4-15.2 4.8-1.3 0.2-2.3 1.3-2.3 2.7v29.6c0 1.2 1 2.2 2.2 2.2 0.2 0 0.3 0 0.5-0.1 4.7-1.2 8.7-3 11.9-5.6 2.8-2.4 5.1-5.7 5.1-9.5v-22.8zm-7.7 7.4v20.6c0 0.5-0.3 1-0.9 1.4-0.8 0.5-1.7 0.5-2.1-0.1-0.1-0.2-0.1-0.4-0.1-0.5v-21.3c0-0.5 0.5-1.1 1.2-1.3 0.2-0.1 0.3-0.1 0.5-0.1 0.7 0 1.2 0.3 1.4 0.9v0.3 0.1z",
    fill: "url(#SVGID_3_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m8.7 116.1c-2.4 0-3.5-0.6-3.5-2.2v-9.4c0-2.5 2.3-2.4 3.4-2.4 3.4 0 4.7 1.5 4.7 3.3 0 1.7-1.2 2.7-2.5 3.2 1.7 0.3 3.3 1.4 3.3 3.6-0.1 2-1.4 3.9-5.4 3.9zm-0.1-13c-0.9 0-1.7 0.1-1.7 1.6v3.6h1.2c2 0 3.4-1 3.4-2.7 0-1.5-0.9-2.5-2.9-2.5zm-0.4 6.1h-1.3v4.5c0 1 0.5 1.4 1.8 1.4 2.4 0 3.5-1.3 3.5-2.9 0-2-1.2-3-4-3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 115.9c-0.2 0-0.5 0.1-0.6 0.1-0.4 0-0.7-0.2-0.8-0.8l-0.1-0.5h-0.1c-0.7 0.9-1.5 1.5-2.6 1.5-2.2 0-3.7-1.6-3.7-4.8 0-3.4 2.2-5.7 4.5-5.7 1.1 0 3.4 0.3 3.4 2v8.2zm-1.6-8.1c0-0.8-0.5-1.2-1.8-1.2-1.4 0-2.9 1.3-2.9 4.4 0 2.8 1.2 3.9 2.5 3.9 1 0 1.7-0.6 2.2-1.2v-5.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m32.5 115.9v-7.2c0-1.1-0.6-2.2-2.4-2.2-1.9 0-2 0.7-2 1.4v8h-1.6v-8.5c0-0.6 0.2-0.9 0.7-1.2 0.6-0.3 1.6-0.5 2.9-0.5 1.7 0 3.9 0.5 3.9 3v7.3h-1.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m38.3 115.9h-1.6v-14.6h1.6v9.2l3.2-3.8c0.7-0.8 1.5-0.9 2-0.9 0.3 0 0.6 0.1 0.6 0.1l-3 3.4c-0.6 0.6-1.2 1.2-1.6 1.2v0.3c0.4 0 1.1 0.3 1.8 1.2l3.3 3.9s-0.3 0.1-0.7 0.1c-0.6 0-1.4-0.1-1.9-0.8-0.8-0.9-3.6-4.5-3.6-4.5v5.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m55 110.8c-0.4 0-0.9-0.1-1.3-0.1v5.3h-1.7v-11.3c0-0.6-0.4-2.6 3.4-2.6 3.4 0 4.9 1.9 4.9 4.2 0 2.7-1.6 4.5-5.3 4.5zm0.5-7.7c-1.9 0-1.7 1.1-1.7 1.6v5c0.3 0 0.8 0.1 1.1 0.1 2.6 0 3.6-1.4 3.6-3.5 0-1.7-0.9-3.2-3-3.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m65.5 116.2c-2.9 0-4.4-2.5-4.4-5.3s1.5-5.2 4.4-5.2c2.8 0 4.4 2.4 4.4 5.2s-1.5 5.3-4.4 5.3zm-0.1-9.6c-1.9 0-2.6 2-2.6 4.1s0.8 4.5 2.7 4.5c2 0 2.7-2.1 2.7-4.1 0-2.2-0.8-4.5-2.8-4.5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m71.8 115.9v-14.5h1.6v14.5h-1.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m82.8 113.2c0 1.8-1.5 2.9-3.5 2.9-1.7 0-3.8-0.9-3.8-3.1h0.4c0.8 0 1.3 0.4 1.5 1 0.2 0.5 0.8 1.3 1.9 1.3 0.9 0 1.9-0.6 1.9-1.7 0-2.5-5.4-2-5.4-5 0-1.7 1.5-2.7 3.4-2.7 1.6 0 3.3 0.8 3.3 2.7-0.7 0.2-1.4 0-1.8-0.9-0.2-0.4-0.8-0.9-1.5-0.9h-0.1c-1 0-1.8 0.6-1.8 1.6 0 2.1 5.5 1.5 5.5 4.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m86.4 115.9h-1.6v-14.6h1.6v9.2l3.2-3.8c0.7-0.8 1.5-0.9 2-0.9 0.3 0 0.6 0.1 0.6 0.1l-3 3.4c-0.6 0.6-1.2 1.2-1.6 1.2v0.3c0.4 0 1.1 0.3 1.8 1.2l3.3 3.9s-0.3 0.1-0.7 0.1c-0.6 0-1.4-0.1-1.9-0.8-0.8-0.9-3.6-4.5-3.6-4.5v5.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m95 104.1c-0.7 0-1.2-0.5-1.2-1.2 0-0.6 0.5-1.2 1.2-1.2s1.2 0.5 1.2 1.2-0.5 1.2-1.2 1.2zm-0.8 11.8v-10h1.6v10h-1.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPko);
export default __webpack_public_path__ + "static/media/pko.d0a72f0742cc15d066dc03469bb317b7.svg";
export { ForwardRef as ReactComponent };